Ext.define('ViewSkps', {
    extend: 'Ext.panel.Panel',
    grid: null,
    windowObject: null,
    id: "skps",
    taskContextMenu: null,
    rowContext: null,
    rebuildGrid: false,
    showState: false,
    statics: {
        accessPropertyName: "access.manage.skps",
        accessPropertyViewName: "access.view.skps"
    },
    cat: "k",
    text: Lang.skps,
    buttonIconCls: "iconSKP",
    layout: 'border',
    frame: false,
    border: false,
    initComponent: function () {
        this.buttonId = "main-view-button-" + this.id;
        this.buildGrid();
        this.items = [{
            region: "north",
            xtype: 'toolbar',
            items: [{
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconNew",
                text: Lang.nowy_skp.capitalise(),
                scope: this,
                handler: this.dodajObiekt,
                disabled: !validPrivilegesOperatorComplex(ViewSkps.accessPropertyName + "/add"),
                hidden: Const.AGGREGATEDCORE
            }, {
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconNew",
                text: Lang.nowy_skpulite.capitalise(),
                handler: this.rejestrujObiekt,
                scope: this,
                disabled: !validPrivilegesOperatorComplex(ViewSkps.accessPropertyName + "/add"),
                hidden: Const.AGGREGATEDCORE || !Const.ENABLESKPULITE
            }, {
                id: this.id + "bedit3",
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconNew",
                text: Lang.klonowanie.capitalise(),
                hidden: Const.CLOUDFLAG,
                scope: this,
                handler: this.edytujObiekt2,
                disabled: !validPrivilegesOperatorComplex(ViewSkps.accessPropertyName + "/add")
            }, {
                id: this.id + "bedit",
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconEdit",
                text: Lang.edytuj.capitalise(),
                scope: this,
                handler: this.edytujObiekt,
                disabled: !validPrivilegesOperatorComplex(ViewSkps.accessPropertyName + "/update"),
                hidden: Const.AGGREGATEDCORE
            }, {
                id: this.id + "bdelete",
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconDelete",
                text: Lang.usun.capitalise(),
                scope: this,
                handler: this.usunObiekt,
                disabled: !validPrivilegesOperatorComplex(ViewSkps.accessPropertyName + "/delete"),
                hidden: Const.AGGREGATEDCORE
            }, {
                id: this.id + "beditflash",
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconProgramowanieFlash",
                text: Lang.programowanie_flash.capitalise(),
                scope: this,
                handler: this.flashObiekt,
                disabled: !validPrivilegesOperatorComplex(ViewSkps.accessPropertyName + "/update"),
                hidden: !validPrivilegesOperatorComplex("access.view.flash") && !(Const.AGGREGATEDCORE && AppOPERATOR.id == 1)
            }, "-", {
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconPDF",
                text: Lang.pdf.capitalise(),
                scope: this,
                handler: this.getDownloadLsPdf,
                hidden: Const.AGGREGATEDCORE
            }, {
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconEXCEL",
                text: Lang.excel.capitalise(),
                scope: this,
                handler: this.getDownloadLsExcel,
                hidden: Const.AGGREGATEDCORE
            }, "-", {
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconRefresh",
                text: Lang.odswiez.capitalise(),
                scope: this,
                handler: this.refreshDatastore
            }, {
                xtype: "box",
                id: this.id + "kontekstfirmybox",
                cls: "kontekstfirmy-box"
            }, {
                id: this.id + "kontekstfirmy",
                xtype: 'label',
                style: 'display:block;margin-right:5px',
                cls: "kontekstfirmy-text"
            }]
        }, {
            region: "center",
            xtype: 'panel',
            frame: false,
            border: false,
            layout: 'fit',
            items: [this.grid]
        }];
        this.callParent(arguments);
    },
    showFirst: function (eventMain) {
        eventMain.on("firmaChangeContext", this.changeContext, this);
    },
    remove: function () {
        this.callParent(arguments);
    },
    show: function () {
        this.showState = true;
        this.callParent(arguments);
        this.changeContextRebuild(null, null);
        this.refreshDatastore();
    },
    hide: function () {
        this.showState = false;
        this.callParent(arguments);
    },
    onDestroy: function () {
        this.taskContextMenu.destroy();
        this.callParent(arguments);
    },
    changeContextRebuild: function (eAppFIRMACTX, eAppFIRMACTXold) {
        var kontekstfirmy = Ext.getCmp(this.id + "kontekstfirmy");
        var kontekstfirmybox = Ext.getCmp(this.id + "kontekstfirmybox");
        if (AppFIRMACTX != null && !Const.AGGREGATEDCORE) {
            kontekstfirmybox.update("<div class='appSetColourRedSplit'></div>");
            kontekstfirmy.setText(Lang.pracujesz_w_kontekscie + AppFIRMACTX.nazwa);
        } else {
            kontekstfirmybox.update("");
            kontekstfirmy.setText("");
        }
        if (this.rebuildGrid) {
            this.rebuildGrid = false;
            var onwer = this.grid.ownerCt;
            Ext.suspendLayouts();
            onwer.remove(this.grid);
            this.grid.destroy();
            this.taskContextMenu.destroy();
            this.buildGrid();
            onwer.add(this.grid);
            Ext.resumeLayouts(true);
        }
    },
    changeContext: function (eAppFIRMACTX, eAppFIRMACTXold) {
        this.rebuildGrid = true;
        if (this.showState) {
            this.changeContextRebuild(null, null);
            this.refreshDatastore();
        }
    },
    buildGrid: function (datals) {
        var cols = [{
            header: "ID",
            width: 145,
            sortable: true,
            dataIndex: 'id',
            filter: {
                type: 'numeric'
            },
            filterable: true,
            hidden: true
        }, {
            header: Lang.nazwa,
            flex: 2,
            sortable: true,
            dataIndex: 'nazwa',
            filter: {
                type: 'string'
            },
            sorter: Ext.bind(customSorterForGrid, this, ["nazwa"], true),
            filterable: true
        }, {
            header: Lang.firma,
            flex: 2,
            sortable: true,
            dataIndex: 'firma',
            filter: {
                type: 'string'
            },
            sorter: Ext.bind(customSorterForGrid, this, ["firma"], true),
            filterable: true,
            hidden: !Const.AGGREGATEDCORE
        }, {
            header: Lang.wersja,
            flex: 2,
            sortable: true,
            dataIndex: 'version',
            filter: {
                type: 'string'
            },
            filterable: true
        }, {
            header: Lang.stan,
            flex: 2,
            sortable: true,
            dataIndex: 'stateopis',
            filter: {
                type: 'string'
            },
            sorter: Ext.bind(customSorterForGrid, this, ["stateopis"], true),
            filterable: true
        }, {
            header: Lang.zbiornik,
            flex: 2,
            sortable: true,
            dataIndex: 'zbiornik',
            filter: {
                type: 'string'
            },
            sorter: Ext.bind(customSorterForGrid, this, ["zbiornik"], true),
            filterable: true
        }, {
            header: Lang.komunikacja,
            flex: 1,
            sortable: true,
            dataIndex: 'iscommunicationok',
            renderer: renderBool3,
            filter: {
                type: 'boolean'
            },
            filterable: true
        }, {
            header: Lang.skp_samodzielne,
            flex: 1,
            sortable: true,
            dataIndex: 'standalonedevice',
            renderer: renderBool3,
            filter: {
                type: 'boolean'
            },
            filterable: true
        }, {
            header: Lang.typ,
            flex: 2,
            sortable: true,
            dataIndex: 'type',
            filterable: true,
            filter: {
                type: 'list',
                options: SKP_TYPES
            },
            hidden: !Const.ENABLESKPULITE,
            renderer: function (value) {
                return SKP_TYPES.find(type => type[0] == value)[1]
            }
        }, {
            header: Lang.data_wygasniecia,
            dataIndex: "billto",
            sortable: true,
            type: 'auto',
            hidden: !Const.ENABLESKPULITE,
            flex: 2
        }, {
            header2: Lang.active,
            menuText: Lang.active,
            header: Ext.DomHelper.markup({
                tag: "div",
                cls: "iconDivCol iconActive",
                cn: [{
                    tag: "span",
                    html: "&nbsp;"
                }, {
                    tag: "div",
                    html: Lang.active
                }]
            }),
            flex: 1,
            sortable: true,
            dataIndex: 'active',
            renderer: renderBool3,
            filter: {
                type: 'boolean'
            },
            filterable: true
        }];
        if (Const.OPTIMALFLAG || Const.BASICFLAG || Const.STANDARDFLAG || Const.STARTERFLAG || Const.CLOUDFLAG) {
            removeObjectFromArrayById(cols, "standalonedevice");
        }
        if (!Const.AGGREGATEDCORE) {
            removeObjectFromArrayById(cols, "firma");
        }
        this.grid = new Ext.ux.grid.GridPanelExd({
            features: [{
                ftype: 'grouping'
            }],
            plugins: {
                gridfilters: true
            },
            store: new Ext.data.Store({
                proxy: new Ext.data.MemoryProxy(),
                autoLoad: true,
                groupField: 'zbiornik',
                sorters: [{
                    property: 'nazwa',
                    direction: "ASC"
                }],
                model: Ext.define(null, {
                    extend: 'Ext.data.Model',
                    idProperty: 'id',
                    fields: [{
                        name: 'id',
                        mapping: 'id'
                    }, {
                        name: 'firma',
                        mapping: 'firma'
                    }, {
                        name: 'nazwa',
                        mapping: 'nazwa'
                    }, {
                        name: 'zbiornik',
                        mapping: 'zbiornik'
                    }, {
                        name: 'version',
                        mapping: 'version'
                    }, {
                        name: 'devid',
                        mapping: 'devid'
                    }, {
                        name: 'active',
                        mapping: 'active'
                    }, {
                        name: 'iscommunicationok',
                        mapping: 'iscommunicationok'
                    }, {
                        name: 'standalonedevice',
                        mapping: 'standalonedevice'
                    }, {
                        name: 'stateopis',
                        mapping: 'stateopis'
                    }, {
                        name: 'type',
                        mapping: 'type'
                    }, {
                        name: 'billto',
                        mapping: 'billto'
                    }]
                }),
                reader: new Ext.data.ArrayReader()
            }),
            columns: cols,
            frame: false,
            border: false,
            stateId: "grid-" + this.id + (AppFIRMACTX == null ? "-all" : "-"),
            stateful: true,
            stripeRows: true,
            enableHdMenu: true,
            selModel: {
                selType: 'rowmodel',
                mode: 'single',
                allowDeselect: false
            }
        });
        this.grid.addListener("rowdblclick", function () {
            if (Const.AGGREGATEDCORE) {
                return;
            }
            if (validPrivilegesOperatorComplex(ViewSkps.accessPropertyName + "/update"))
                this.edytujObiekt();
        }, this);
        this.grid.addListener("render", function () {
            this.manageSelect(this.grid.getSelectionModel());
        }, this);
        this.grid.addListener("select", function (selectionModel, record, index) {
            this.manageSelect(selectionModel);
        }, this);
        this.grid.addListener("selectionchange", function (selectionModel, record, index) {
            this.manageSelect(selectionModel);
        }, this);
        this.taskContextMenu = new Ext.menu.Menu();
        this.taskContextMenu.add([{
            iconAlign: 'left',
            iconCls: "iconNew",
            text: Lang.nowy.capitalise(),
            scope: this,
            handler: this.dodajObiekt,
            disabled: !validPrivilegesOperatorComplex(ViewSkps.accessPropertyName + "/add"),
            hidden: Const.AGGREGATEDCORE
        }, {
            id: this.id + "bedit4",
            iconAlign: 'left',
            iconCls: "iconNew",
            text: Lang.klonowanie.capitalise(),
            hidden: Const.CLOUDFLAG,
            scope: this,
            handler: this.edytujObiekt2,
            disabled: !validPrivilegesOperatorComplex(ViewSkps.accessPropertyName + "/add")
        }, {
            id: this.id + "bedit2",
            iconAlign: 'left',
            iconCls: "iconEdit",
            hidden: Const.AGGREGATEDCORE,
            text: Lang.edytuj.capitalise(),
            scope: this,
            handler: this.edytujObiekt,
            disabled: !validPrivilegesOperatorComplex(ViewSkps.accessPropertyName + "/update")
        }, {
            id: this.id + "bdelete2",
            iconAlign: 'left',
            iconCls: "iconDelete",
            hidden: Const.AGGREGATEDCORE,
            text: Lang.usun.capitalise(),
            scope: this,
            handler: this.usunObiekt,
            disabled: !validPrivilegesOperatorComplex(ViewSkps.accessPropertyName + "/delete")
        }, "-", {
            iconAlign: 'left',
            iconCls: "iconPDF",
            text: Lang.pdf.capitalise(),
            scope: this,
            hidden: Const.AGGREGATEDCORE,
            handler: this.getDownloadLsPdf
        }, {
            iconAlign: 'left',
            iconCls: "iconEXCEL",
            text: Lang.excel.capitalise(),
            scope: this,
            hidden: Const.AGGREGATEDCORE,
            handler: this.getDownloadLsExcel
        }, "-", {
            iconAlign: 'left',
            iconCls: "iconRefresh",
            text: Lang.odswiez.capitalise(),
            scope: this,
            handler: this.refreshDatastore
        }]);
        this.grid.addListener("rowcontextmenu", function (grid, record, tr, rowIndex, e) {
            this.rowContext = grid.getStore().getAt(rowIndex);
            this.manageSelect();
            this.taskContextMenu.showAt(e.getXY());
            e.preventDefault();
        }, this);
        this.taskContextMenu.addListener("hide", function () {
            this.rowContext = null;
        }, this);
        this.grid.addListener("containercontextmenu", function (grid, e) {
            this.rowContext = null;
            this.manageSelect();
            this.taskContextMenu.showAt(e.getXY());
            e.preventDefault();
        }, this);
    },
    manageSelect: function () {
        var bedit = Ext.getCmp(this.id + "bedit");
        var bedit3 = Ext.getCmp(this.id + "bedit3");
        var bdelete = Ext.getCmp(this.id + "bdelete");
        var bedit2 = Ext.getCmp(this.id + "bedit2");
        var bedit4 = Ext.getCmp(this.id + "bedit4");
        var bdelete2 = Ext.getCmp(this.id + "bdelete2");
        if (!this.grid.getSelectionModel().hasSelection() || this.grid.getSelectionModel().getSelection() == null || this.grid.getSelectionModel().getSelection().length == 0) {
            bdelete.setDisabled(true);
            bedit.setDisabled(true);
            bedit3.setDisabled(true);
        } else {
            var row = this.grid.getSelectionModel().getSelection()[0];
            bdelete.setDisabled(!validPrivilegesOperatorComplex(ViewSkps.accessPropertyName + "/delete"));
            bedit.setDisabled(!validPrivilegesOperatorComplex(ViewSkps.accessPropertyName + "/update"));
            bedit3.setDisabled(!validPrivilegesOperatorComplex(ViewSkps.accessPropertyName + "/add") || row.data.type == Const.TYPE_SKP_SKPULITE);
        }
        if (this.rowContext == null) {
            bdelete2.setDisabled(true);
            bedit2.setDisabled(true);
            bedit4.setDisabled(true);
        } else {
            bdelete2.setDisabled(!validPrivilegesOperatorComplex(ViewSkps.accessPropertyName + "/delete"));
            bedit2.setDisabled(!validPrivilegesOperatorComplex(ViewSkps.accessPropertyName + "/update"));
            bedit4.setDisabled(!validPrivilegesOperatorComplex(ViewSkps.accessPropertyName + "/add") || this.rowContext.data.type == Const.TYPE_SKP_SKPULITE);
        }
    },
    getDownloadLsPdf: function () {
        postFormAsync("rest/pdfexcelexport/downloadExport", {
            format: "pdf",
            name: Lang.skps,
            defd: Ext.encode(this.grid.getDefGridDataCSF({
                colsEx: [],
                colsIn: [],
                useRenderer: true,
                fnd: function (v, c, metaData, record, rowIndex, colIndex, store) {
                    if (c == "active" || c == "iscommunicationok" || c == "standalonedevice") {
                        if (v == 'true')
                            v = Lang.tak;
                        else
                            v = Lang.nie;
                    }
                    return v;
                }
            }))
        }, null);
    },
    getDownloadLsExcel: function () {
        postFormAsync("rest/pdfexcelexport/downloadExport", {
            format: "excel",
            name: Lang.skps,
            defd: Ext.encode(this.grid.getDefGridDataCSF({
                colsEx: [],
                colsIn: [],
                useRenderer: true,
                fnd: function (v, c, metaData, record, rowIndex, colIndex, store) {
                    if (c == "active" || c == "iscommunicationok" || c == "standalonedevice") {
                        if (v == 'true')
                            v = Lang.tak;
                        else
                            v = Lang.nie;
                    }
                    return v;
                }
            }))
        }, null);
    },
    refreshDatastore: function () {
        updateCzasRefreshSerwer();
        if (this.grid && this.grid.rendered)
            this.grid.mask();
        sendAjaxDataJsonRpcL("rest/skp/getList", null, this, function (data) {
            if (this.grid && this.grid.rendered)
                this.grid.unmask();
            if (data.status) {
                this.grid.store.loadData(data.data);
            } else {
                Ext.MessageBox.alert(Lang.error, data.error);
            }
        });
    },
    dodajObiekt: function () {
        this.windowObject = Ext.create('WindowSkps', {
            callbackF: Ext.Function.bind(this.refreshDatastore, this)
        });
        this.windowObject.showW(0);
    },
    flashObiekt: function () {
        windowObjectFlash = Ext.create('WindowCfgProgramFlash', {
            typeo: "skp"
        });
        windowObjectFlash.showW();
        windowObjectFlash.on("close", this.refreshDatastore, this);
    },
    edytujObiekt: function () {
        var id = 0;
        var type;
        if (!this.grid.getSelectionModel().hasSelection() && this.rowContext == null) {
            Ext.MessageBox.alert(Lang.error, Lang.prosze_wybrac_obiekt);
            return;
        } else {
            if (this.rowContext != null) {
                id = this.rowContext.id;
                type = this.rowContext.type;
            } else if (this.grid.getSelectionModel().getSelection() != null && this.grid.getSelectionModel().getSelection().length > 0) {
                id = this.grid.getSelectionModel().getSelection()[0].id;
                type = this.grid.getSelectionModel().getSelection()[0].data.type;
            }
        }
        if (type == Const.TYPE_SKP_SKP) {
            this.windowObject = Ext.create('WindowSkps', {
                callbackF: Ext.Function.bind(this.refreshDatastore, this)
            });
            this.windowObject.showW(id);
        } else if (type == Const.TYPE_SKP_SKPULITE) {
            this.windowObject = Ext.create('WindowSkpulite', {
                callbackF: Ext.Function.bind(this.refreshDatastore, this)
            });
            this.windowObject.showW(id, null);
        }
    },
    edytujObiekt2: function () {
        var id = 0;
        var type;
        if (!this.grid.getSelectionModel().hasSelection() && this.rowContext == null) {
            Ext.MessageBox.alert(Lang.error, Lang.prosze_wybrac_obiekt);
            return;
        } else {
            if (this.rowContext != null) {
                id = this.rowContext.id;
                type = this.rowContext.type;
            } else if (this.grid.getSelectionModel().getSelection() != null && this.grid.getSelectionModel().getSelection().length > 0) {
                id = this.grid.getSelectionModel().getSelection()[0].id;
                type = this.grid.getSelectionModel().getSelection()[0].data.type;
            }
        }
        if (type == Const.TYPE_SKP_SKPULITE) {
            return;
        }
        this.windowObject = Ext.create('WindowSkps', {
            callbackF: Ext.Function.bind(this.refreshDatastore, this)
        });
        this.windowObject.showW(id, true);
    },
    rejestrujObiekt: function () {
        this.windowObject = Ext.create('WindowRejestrujSkpulite', {
            callbackF: Ext.Function.bind(this.refreshDatastore, this)
        });
        this.windowObject.show();
    },
    usunObiekt: function () {
        var id = 0;
        if (!this.grid.getSelectionModel().hasSelection() && this.rowContext == null) {
            Ext.MessageBox.alert(Lang.error, Lang.prosze_wybrac_obiekt);
            return;
        } else {
            if (this.rowContext != null) {
                id = this.rowContext.id;
            } else if (this.grid.getSelectionModel().getSelection() != null && this.grid.getSelectionModel().getSelection().length > 0) {
                id = this.grid.getSelectionModel().getSelection()[0].id;
            }
        }
        Ext.MessageBox.show({
            title: Lang.usuwanie,
            message: Lang.czy_napewno_usunac_obiekt,
            buttons: Ext.MessageBox.YESNO,
            scope: this,
            fn: function (btn) {
                if (btn == "yes") {
                    sendAjaxDataJsonRpcL("rest/skp/deleteObject", {
                        id: id
                    }, this, function (data) {
                        if (data.status) {
                        } else {
                            Ext.MessageBox.alert(Lang.error, data.error);
                        }
                        this.refreshDatastore();
                    });
                }
            }
        });
    }
});
